import qs from 'qs'
import RESTFUL_axios from '@/api/restful_axois'
import apiError from '@/api/apierror'
import { replaceOrigin } from '@/utils/common'

const trim = (str) => {
  if (!str) return ''
  var reg = /^(\s|\xA0)+|(\s|\xA0)+$/g
  return str.replace(reg, '')
}

const RESTFUL_fn = (apiType, reqData) => {
  var apiName = 'publesson'
  var reqName = apiName + '_' + apiType
  var apiConfigs = {
    _getLessonInfo: {
      url: '/saasajax/school.ajax.php?action=getPublicClassInfo',
      data: () => {
        var data = {}
        if (reqData.lessonKey) {
          data.lessonKey = reqData.lessonKey
        } else {
          data.classSN = reqData.classSN
        }
        return data
      },
      transformResponse: (res) => {
        switch (res.error_info.errno) {
          case 1:
            var resData = res.data
            var lessonInfoData = {}
            if (resData) {
              let studentList = []
              let _courseWare = resData.courseWare && JSON.parse(resData.courseWare)
              let _courseLogo = ''
              if (_courseWare.CourseImg) {
                _courseLogo = '/' + _courseWare.CourseImg.Path + _courseWare.CourseImg.Mpic
              }
              if (resData.studentList) {
                resData.studentList.map((item) => {
                  const _itemUrl = item.avatarUrl && JSON.parse(item.avatarUrl)
                  studentList.push({
                    url: '/' + _itemUrl.Path + _itemUrl.Mpic,
                  })
                })
              }
              lessonInfoData = {
                lessonId: resData.classId,
                courseLogo: _courseLogo,
                lessonName: resData.className,
                lessonStartTime: resData.classBtime * 1000,
                lessonEndtTime: resData.classEtime * 1000,
                schoolName: resData.schoolName,
                druation: (resData.classEtime - resData.classBtime) * 1000,
                teacherLogo: resData.teacherLogo,
                teacherName: resData.teacherName,
                schoolIntroduction: resData.schoolIntroduce,
                classStudentNum: +resData.classStudentNum,
                studentList: studentList,
                signUpStatus:
                  resData.classStatus == '3' ? 'lessonEnd' : !(resData.studentNum * 1 > resData.classStudentNum * 1) ? 'lessonStuFull' : '',
              }
              lessonInfoData.courseLogo && (lessonInfoData.courseLogo = lessonInfoData.courseLogo.replace('_300', '_100'))
            }
            return {
              lessonInfoData: lessonInfoData,
            }
          case 104:
          case 304:
          case 212:
            return res.error_info.errno
          default:
            apiError({
              name: reqName,
              code: res.error_info.errno,
              intro: res.error_info.error,
              url: apiConfigs['_' + apiType].url,
              req: reqData,
              res: res,
            })
        }
      },
    },
    // 检查手机号,邮箱是否注册
    _userRegister: {
      // url: '/saasajax/user.ajax.php?action=userRegister',
      url: '/usercenter/v2/web/user/userRegister',
      data: function () {
        var phoneNumber = trim(reqData.mobile)
        const mobile = phoneNumber ? (reqData.selectArea == '0086' ? phoneNumber : reqData.selectArea + '-' + phoneNumber) : ''
        var serverPostData = {
          mobile,
          email: reqData.email,
          verificationCode: trim(reqData.verificationCode),
          nickName: reqData.nickName,
          password: trim(reqData.password),
          isLogin: reqData.isLogin,
          source: 2, // 内容来源:1-班级 2-公开课
        }
        return serverPostData
      },
      transformResponse: function (res) {
        switch (res.error_info.errno) {
          case 1:
          case 111:
          case 1040:
          case 1041:
          case 1042:
          case 1043:
          case 1008:
          case 100:
          case 101:
          case 102:
          case 108:
          case 109:
          case 110:
          case 113:
          case 133:
          case 134:
          case 135:
          case 136:
          case 166:
          case 20704:
          case 20718:
          case 20727:
          case 20728:
          case 20729:
          case 20730:
          case 20731:
          case 20732:
          case 20733:
          case 20734:
            return res.error_info.errno
          default:
            apiError({
              name: reqName,
              code: res.error_info.errno,
              intro: res.error_info.error,
              url: apiConfigs['_' + apiType].url,
              req: reqData,
              res: res,
            })
        }
      },
    },
    // 自助添加公开课学生
    _addlessonStu: {
      url: '/saasajax/openclass.ajax.php?action=addClassStudent',
      data: function () {
        var phoneNumber = trim(reqData.mobile)
        const mobile = phoneNumber ? (reqData.selectArea == '0086' ? phoneNumber : reqData.selectArea + '-' + phoneNumber) : ''
        var serverPostData = {
          classId: reqData.classId,
          mobile,
          identifyCode: trim(reqData.identifyCode),
          email: reqData.email,
          name: reqData.name,
        }
        reqData.nickName && (serverPostData.name = reqData.nickName)
        return serverPostData
      },
      transformResponse: function (res) {
        switch (res.error_info.errno) {
          case 1:
          case 111:
          case 113:
          case 128:
          case 129:
          case 153:
          // case 145:
          case 157:
          case 166:
          case 212:
          case 304:
          case 329:
            return res.error_info.errno
          default:
            apiError({
              name: reqName,
              code: res.error_info.errno,
              intro: res.error_info.error,
              url: apiConfigs['_' + apiType].url,
              req: reqData,
              res: res,
            })
        }
      },
    },
    _check: {
      // url: '/saasajax/user.ajax.php?action=checkRegister',
      url: '/usercenter/v2/web/user/checkVerificationCode',
      data: function () {
        var serverPostData = {
          mobile: reqData.telephone.replace(/^(\s|\xA0)+|(\s|\xA0)+$/g, ''),
          verificationCode: reqData.verificationCode,
        }
        return serverPostData
      },
      transformResponse: function (res) {
        switch (res.error_info.errno) {
          case 1:
          case 113:
            return false
          case 104:
          case 134:
            return res.error_info.errno
          case 135:
            return true
          default:
            apiError({
              name: reqName,
              code: res.error_info.errno,
              intro: res.error_info.error,
              url: apiConfigs['_' + apiType].url,
              req: reqData,
              res: res,
            })
        }
      },
    },
    // 发送验证码并返回用户是否注册
    _sendCode: {
      // url: '/saasajax/user.ajax.php?action=sendCodeAndCheckRegister',
      url: '/usercenter/v2/web/user/sendCodeAndCheckRegister',
      // host: replaceOrigin(),
      data: function () {
        var phoneNumber = trim(reqData.mobile)
        const mobile = phoneNumber ? (reqData.selectArea == '0086' ? phoneNumber : reqData.selectArea + '-' + phoneNumber) : ''
        var serverPostData = {
          mobile,
          sceneCode: 2, // sceneCode=2 发送短信场景参数 登录
          type: reqData.type,
          email: reqData.email,
          verifyToken: reqData.vToken,
          verifyType: reqData.vType,
          // ...reqData.captcha,
          // ticket: reqData.ticket,
          // randStr: reqData.randStr
          // graphicCode:reqData.picCode.replace(/^(\s|\xA0)+|(\s|\xA0)+$/g, '')
        }
        return serverPostData
      },
      transformResponse: function (res) {
        switch (res.error_info.errno) {
          case 1:
            let resData = res.data
            if (resData) {
              return resData.isRegister * 1 ? true : false
            }
            break
          case 104:
          case 108:
          case 109:
          case 110:
          case 134:
          case 100:
          case 101:
          case 102:
          case 113:
          case 133:
          case 135:
          case 136:
          case 166:
          case 20704:
          case 20718:
          case 20727:
          case 20728:
          case 20729:
          case 20730:
          case 20731:
          case 20732:
          case 20733:
          case 20734:
            return res.error_info.errno
          default:
            apiError({
              name: reqName,
              code: res.error_info.errno,
              intro: res.error_info.error,
              url: apiConfigs['_' + apiType].url,
              req: reqData,
              res: res,
            })
        }
      },
    },
  }
  return RESTFUL_axios({
    reqName: reqName,
    reqConfig: apiConfigs['_' + apiType],
    reqData: reqData,
  })
}
export default RESTFUL_fn
